'use client';
import { useFrame } from '@react-three/fiber';
import { useLayoutEffect, useRef } from 'react';
import { resolveGuidanceCenter } from '../_pure/visualGuidance.js';
import { createGuidanceOrbit } from '../guidanceOrbit.js';
import { useVisualizationDiagnostics } from '../diagnostics.js';
function reportGuidance(event, detail) {
    const entry = { event, wallTimeMs: performance.now(), ...detail };
    console.debug('[visualization-diagnostics]', entry);
    window.dispatchEvent(new CustomEvent('visualization-diagnostic', { detail: entry }));
}
export function GuidanceOrbit(props) {
    const { guidance: diagnosticsEnabled } = useVisualizationDiagnostics();
    const diagnostics = useRef(diagnosticsEnabled);
    diagnostics.current = diagnosticsEnabled;
    const latest = useRef(props);
    latest.current = props;
    const owner = useRef(undefined);
    const orbitSpec = props.guidance?.orbit;
    const targets = useRef(orbitSpec?.targets);
    if (targets.current?.length !== orbitSpec?.targets.length
        || orbitSpec?.targets.some((target, index) => {
            const previous = targets.current?.[index];
            return previous?.targetKind !== target.targetKind
                || (target.targetKind === 'item'
                    ? previous?.targetKind !== 'item' || previous.itemKey !== target.itemKey
                    : previous?.targetKind !== 'constellation' || previous.constellationKey !== target.constellationKey);
        }))
        targets.current = orbitSpec?.targets;
    const orbitTargets = targets.current;
    const emphasisSignature = diagnosticsEnabled ? JSON.stringify(props.guidance?.emphases) : undefined;
    useLayoutEffect(() => {
        if (!diagnosticsEnabled)
            return;
        reportGuidance('visual-emphasis', { key: latest.current.guidance?.key,
            emphases: latest.current.guidance?.emphases ?? [] });
    }, [diagnosticsEnabled, props.guidance?.key, emphasisSignature]);
    useLayoutEffect(() => {
        const { guidance, camera, frame } = latest.current;
        if (!guidance?.orbit || !camera)
            return;
        const center = resolveGuidanceCenter(frame, guidance.orbit.targets);
        const orbit = createGuidanceOrbit(camera, center, guidance.orbit.durationMs, guidance.orbit.angleRadians, (event, pose) => {
            if (diagnostics.current)
                reportGuidance(`visual-orbit-${event}`, { key: guidance.key, center, targets: guidance.orbit?.targets, pose });
        });
        owner.current = orbit;
        return () => { orbit.dispose(); owner.current = undefined; };
    }, [props.guidance?.key, props.camera, orbitSpec?.durationMs, orbitSpec?.angleRadians, orbitTargets]);
    useFrame((_, delta) => {
        const { paused, transitionActive } = latest.current;
        owner.current?.tick(delta * 1000, paused, transitionActive);
    });
    return null;
}
